// extracted by mini-css-extract-plugin
export default {"Button":"MailButton_Button__l8f51","DisabledButton":"MailButton_DisabledButton__wJaHi"};